export const key = {
    major: {
        0: [], // C major (no sharps or flats)
        1: ["F#"], // G major (1 sharp - F#)
        2: ["F#", "C#"], // D major (2 sharps - F#, C#)
        3: ["F#", "C#", "G#"], // A major (3 sharps - F#, C#, G#)
        4: ["F#", "C#", "G#", "D#"], // E major (4 sharps - F#, C#, G#, D#)
        5: ["F#", "C#", "G#", "D#", "A#"], // B major (5 sharps - F#, C#, G#, D#, A#)
        6: ["F#", "C#", "G#", "D#", "A#", "E#"], // F# major (6 sharps - F#, C#, G#, D#, A#, E#)
        7: ["F#", "C#", "G#", "D#", "A#", "E#", "B#"], // C# major (7 sharps - F#, C#, G#, D#, A#, E#, B#)
        '-1': ["Bb"], // F major (1 flat - Bb)
        '-2': ["Bb", "Eb"], // Bb major (2 flats - Bb, Eb)
        '-3': ["Bb", "Eb", "Ab"], // Eb major (3 flats - Bb, Eb, Ab)
        '-4': ["Bb", "Eb", "Ab", "Db"], // Ab major (4 flats - Bb, Eb, Ab, Db)
        '-5': ["Bb", "Eb", "Ab", "Db", "Gb"], // Db major (5 flats - Bb, Eb, Ab, Db, Gb)
        '-6': ["Bb", "Eb", "Ab", "Db", "Gb", "Cb"], // Gb major (6 flats - Bb, Eb, Ab, Db, Gb, Cb)
        '-7': ["Bb", "Eb", "Ab", "Db", "Gb", "Cb", "Fb"], // Cb major (7 flats - Bb, Eb, Ab, Db, Gb, Cb, Fb)
    },
    minor: {
        0: [], // A minor (no sharps or flats)
        1: ["F#"], // E minor (1 sharp - F#)
        2: ["F#", "C#"], // B minor (2 sharps - F#, C#)
        3: ["F#", "C#", "G#"], // F# minor (3 sharps - F#, C#, G#)
        4: ["F#", "C#", "G#", "D#"], // C# minor (4 sharps - F#, C#, G#, D#)
        5: ["F#", "C#", "G#", "D#", "A#"], // G# minor (5 sharps - F#, C#, G#, D#, A#)
        6: ["F#", "C#", "G#", "D#", "A#", "E#"], // D# minor (6 sharps - F#, C#, G#, D#, A#, E#)
        7: ["F#", "C#", "G#", "D#", "A#", "E#", "B#"], // A# minor (7 sharps - F#, C#, G#, D#, A#, E#, B#)
        '-1': ["Bb"], // D minor (1 flat - Bb)
        '-2': ["Bb", "Eb"], // G minor (2 flats - Bb, Eb)
        '-3': ["Bb", "Eb", "Ab"], // C minor (3 flats - Bb, Eb, Ab)
        '-4': ["Bb", "Eb", "Ab", "Db"], // F minor (4 flats - Bb, Eb, Ab, Db)
        '-5': ["Bb", "Eb", "Ab", "Db", "Gb"], // Bb minor (5 flats - Bb, Eb, Ab, Db, Gb)
        '-6': ["Bb", "Eb", "Ab", "Db", "Gb", "Cb"], // Eb minor (6 flats - Bb, Eb, Ab, Db, Gb, Cb)
        '-7': ["Bb", "Eb", "Ab", "Db", "Gb", "Cb", "Fb"], // Ab minor (7 flats - Bb, Eb, Ab, Db, Gb, Cb, Fb)
    }
};
